export type TrafficClass = "automated" | "human";

export const TRAFFIC_CLASS_PROPERTY = "traffic_class";

export const AUTOMATED_TRAFFIC_HEADER = "x-repackify-automated";

export const AUTOMATED_USER_AGENT_PATTERN =
  /bot(?:[-/;),]|$)|crawler|spider|crawling|preview|validator|lighthouse|pagespeed|pingdom|uptime|monitor|headless|phantom|slurp|facebookexternalhit|twitterbot|linkedinbot|whatsapp|discordbot|telegrambot|google-inspectiontool|lightpanda/i;

const SERVER_TIMING_NAME = "traffic-class";

export const AUTOMATED_SERVER_TIMING = `${SERVER_TIMING_NAME};desc=automated`;

export function hasAutomatedServerTiming(
  entries: readonly { name: string; description: string }[],
): boolean {
  return entries.some(
    (entry) =>
      entry.name === SERVER_TIMING_NAME && entry.description === "automated",
  );
}
